import { CustomRouteSegment } from '../../types/CustomRoute';

export const isLinkedToNextSegment = (segments: CustomRouteSegment[], segmentIndex?: number) => {
  if (segmentIndex === undefined || segmentIndex === segments.length - 1) {
    return false;
  }

  const currentSegment = segments[segmentIndex];
  const nextSegment = segments[segmentIndex + 1];
  if (!currentSegment || !nextSegment) {
    return false;
  }

  return currentSegment.isLinkedToNextSegment;
};

export const isLinkedToPreviousSegment = (segments: CustomRouteSegment[], segmentIndex?: number) => {
  if (segmentIndex === undefined || segmentIndex === 0) {
    return false;
  }

  const previousSegment = segments[segmentIndex - 1];
  if (!previousSegment) {
    return false;
  }

  return previousSegment.isLinkedToNextSegment;
};

export const canLinkSegments = (previousSegment?: CustomRouteSegment, nextSegment?: CustomRouteSegment) => {
  if (!previousSegment || !nextSegment) {
    return false;
  }

  if (previousSegment.isLinkedToNextSegment) {
    return false;
  }

  if (previousSegment.paths.length === 0 || nextSegment.paths.length === 0) {
    return false;
  }

  return true;
};

const canLinkSegmentToNextSegment = (segments: CustomRouteSegment[], segmentIndex?: number) => {
  if (segmentIndex === undefined || segmentIndex === segments.length - 1) {
    return false;
  }

  const previousSegment = segments[segmentIndex];
  const nextSegment = segments[segmentIndex + 1];

  return canLinkSegments(previousSegment, nextSegment);
};

const canLinkSegmentToPreviousSegment = (segments: CustomRouteSegment[], segmentIndex?: number) => {
  if (segmentIndex === undefined || segmentIndex === 0) {
    return false;
  }

  const previousSegment = segments[segmentIndex - 1];
  const nextSegment = segments[segmentIndex];

  return canLinkSegments(previousSegment, nextSegment);
};

export const getPointsToLinkSegmentToNextSegment = (segments: CustomRouteSegment[], segmentIndex?: number) => {
  if (!canLinkSegmentToNextSegment(segments, segmentIndex)) {
    return undefined;
  }

  const segment = segments[segmentIndex!];
  const endPath = segment.paths[segment.paths.length - 1];
  const endPoint = endPath.points[endPath.points.length - 1];
  const nextSegment = segments[segmentIndex! + 1];
  const startPoint = nextSegment.paths[0].points[0];
  return [endPoint, startPoint];
};

export const getPointsToLinkSegmentToPreviousSegment = (segments: CustomRouteSegment[], segmentIndex?: number) => {
  if (!canLinkSegmentToPreviousSegment(segments, segmentIndex)) {
    return undefined;
  }

  const segment = segments[segmentIndex!];
  const previousSegment = segments[segmentIndex! - 1];
  const endPath = previousSegment.paths[previousSegment.paths.length - 1];
  const endPoint = endPath.points[endPath.points.length - 1];
  const startPoint = segment.paths[0].points[0];
  return [endPoint, startPoint];
};
